import footerLogo from './../../../../website/assets/images/fulllogo_transparent_nobuffer.png'

export default function HomePageFooter() {
  return (
    <footer class="footer">
    <div>
            <img className="footer-logo-img" src={footerLogo} alt="Logo"/>
            </div>
    <div class="social-icons">
      <a href="#"><i class="fab fa-facebook-f"></i></a>
      <a href="#"><i class="fab fa-instagram"></i></a>
      <a href="#"><i class="fab fa-twitter"></i></a>
      <a href="#"><i class="fab fa-youtube"></i></a>
    </div>
    <p style={{marginTop:'15px', fontSize: '14px'}}>© 2026 MOTOURAX. All Rights Reserved.</p>
  </footer>
  );
}